import React from 'react'
import { Card,Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import Snakebg from '../../assets/snake.png'
import s1 from '../../assets/snake/bg.png'
import s2 from '../../assets/snake/food.png'
import s3 from '../../assets/snake/sHead.png'
import s4 from '../../assets/snake/sBody.png'
class SnakeModal extends React.Component{
    state = {
        modal: false
        
    }
    OpenCLoseModal = ()=>{
        this.setState({modal: !this.state.modal});
    }
    GameLogic(){
        
    
        if (document.documentElement.clientWidth > 450){
            const canvas =document.getElementById('canvas');
            const btn =document.getElementById('snakebtn');
            btn.hidden = true;
            canvas.hidden = false;
            const context = canvas.getContext('2d');


            var move=true;
            const dx=25;
            let snake=[];
            let score=0;
            let dir=" ";

            const bg=new Image();
            bg.src= s1;
            const foodI=new Image();
            foodI.src=s2;
            const sHead=new Image();
            sHead.src=s3;
            const sBody=new Image();
            sBody.src=s4;
            snake[0]={x:25,y:75}

            let food={
                x:Math.floor((Math.random()*14)+1)*dx,
                y:Math.floor((Math.random()*13)+2)*dx
            }

            var direction = function(event){
                if(event.keyCode == 37 && dir != "R" && move){
                    dir="L";
                    move=false;
                }
                else if(event.keyCode==38&&dir!="D"&&move){
                    dir="U";
                    move=false;
                }
                else if(event.keyCode==39&&dir!="L"&&move){
                    dir="R";
                    move=false;
                }
                else if(event.keyCode==40&&dir!="U"&&move){
                    dir="D";
                    move=false;
                }

            }

            var collision=function(head,array){
                for(let i=0;i<array.length;i++)
                if(head.x==array[i].x&&head.y==array[i].y){
                    return true;
                }
                    return false;
            }
            document.addEventListener("keydown",direction);

            var draw=function(){
                context.drawImage(bg,0,0);
                move=true;
                    let snakeX=snake[0].x;
                    let snakeY=snake[0].y;

                    if(dir=="L") snakeX-= dx;
                    if(dir=="U") snakeY-= dx;
                    if(dir=="D") snakeY+= dx;
                    if(dir=="R") snakeX+= dx;



                for(let i=0;i<snake.length;i++){
                    i==0?context.drawImage(sHead,snake[i].x,snake[i].y):context.drawImage(sBody,snake[i].x,snake[i].y);
                }

                    context.drawImage(foodI,food.x,food.y);
                    for(let i=0;i<snake.length;i++){
                        if(snake[i].x==food.x&&snake[i].y==food.y)
                        food={
                            x:Math.floor((Math.random()*14)+1)*dx,
                            y:Math.floor((Math.random()*13)+2)*dx
                        }
                    }

                    if(snakeX==food.x&&snakeY==food.y){
                        if(score<182){
                            score++;
                        for(let i=0;i<snake.length;i++){
                            if(snake[i].x==food.x&&snake[i].y==food.y)
                            food={
                                x:Math.floor((Math.random()*14)+1)*dx,
                                y:Math.floor((Math.random()*13)+2)*dx
                            }          }
                    }
                        else{
                            alert("CONGRATULATION!!! \n YOU WIN!");
                        }

                    }else snake.pop();

                    context.fillStyle="white";
                    context.font="45px Consolas"
                    context.fillText("Score:"+score,100,40);
                    let newHead={
                        x:snakeX,
                        y:snakeY
                    }

                    if(snakeX<=0||snakeX>=375||snakeY<=25||snakeY>=375||collision(newHead,snake)){
                        clearInterval(loop);
                        context.drawImage(bg,0,0);
                        context.fillStyle="white";
                        context.font="45px Consolas"
                        context.fillText("YOU LOSE!",100,40);
                        if(collision(newHead,snake))
                        for(let i=0;i<snake.length;i++)
                                i==0?context.drawImage(sHead,snake[i].x,snake[i].y):context.drawImage(sBody,snake[i].x,snake[i].y);
                        snake.unshift(newHead);
                        if(snakeX>=375)
                        for(let i=0;i<snake.length;i++)
                            i==0?context.drawImage(sHead,snake[i].x-dx,snake[i].y):context.drawImage(sBody,snake[i].x-dx,snake[i].y);
                        else if(snakeX<=25)
                        for(let i=0;i<snake.length;i++)
                            i==0?context.drawImage(sHead,snake[i].x+dx,snake[i].y):context.drawImage(sBody,snake[i].x+dx,snake[i].y);
                        else if(snakeY>=375)
                        for(let i=0;i<snake.length;i++)
                            i==0?context.drawImage(sHead,snake[i].x,snake[i].y-dx):context.drawImage(sBody,snake[i].x,snake[i].y-dx);
                        else if(snakeY<=25)
                            for(let i=0;i<snake.length;i++)
                                i==0?context.drawImage(sHead,snake[i].x,snake[i].y+dx):context.drawImage(sBody,snake[i].x,snake[i].y+dx);
                    }
                    snake.unshift(newHead);

                    }
            var restart=function(){
                snake.length=0;
                score=0;
                snake[0]={x:25,y:75}
                dir=" ";

                food={
                x:Math.floor((Math.random()*14)+1)*dx,
                y:Math.floor((Math.random()*13)+2)*dx
                }
                clearInterval(loop);
                loop=setInterval(() => draw(),150);
            }
            let loop = setInterval(() => draw(), 150);
            //=setInterval(draw,150);
        }else{
            alert("Necesitas una pantalla más grande para jugar a este juego")
        }
        

    }
    render(){
        return(
            <>
            <Card className = "shadow">
                <div className  = "img-animation">
                    <Card.Img variant="top" src={Snakebg} />
                </div>
                <Card.Body>
                    <Card.Title>Snake Game</Card.Title>
                    <Card.Text>
                    Juego clásico de la serpiente, jugable solo para computadoras
                    </Card.Text>
                    <Button onClick = {()=>this.OpenCLoseModal()} className = "btn custom-btn">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        Jugar
                        </Button>
                </Card.Body>
            </Card>
            <Modal 
                show = {this.state.modal}
                onHide = {()=>this.OpenCLoseModal()}>
                    <Modal.Header closeButton>Snake Game!</Modal.Header>
                    <Modal.Body>
                    <div className = "text-center">
                        <canvas hidden id="canvas" width="400" height="400">Click para iniciar</canvas>
                        <button id = "snakebtn" onClick = {()=>this.GameLogic()} content="text" className="btn btn-primary" >
                            Iniciar
                        </button>
                        
                        
                    </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick = {()=>this.OpenCLoseModal()} className="btn btn-danger">Cerrar</button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}   
export default SnakeModal